import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Download } from "lucide-react";
import { api } from "@/lib/api";
import { cleanParams, downloadExport, fmtValue, moneyHeader } from "@/lib/analytics";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";

export const ExportButtons = ({ params, label, testId }) => (
  <div className="flex gap-1" data-testid={testId}>
    {["xlsx", "csv", "pdf"].map((fm) => <Button key={fm} size="sm" variant="outline" className="h-8 gap-1 rounded-full text-xs" onClick={() => downloadExport({ ...params, format: fm }, label)}
      data-testid={`${testId}-${fm}`}><Download className="h-3.5 w-3.5" />{fm.toUpperCase()}</Button>)}
  </div>
);

// KPI -> lista filtrata (paginata) -> scheda del record
export const DrillSheet = ({ drill, filters, canExport, onClose }) => {
  const [page, setPage] = useState(1);
  const [d, setD] = useState(null);
  const [last, setLast] = useState(drill);
  if (drill && drill !== last) { setLast(drill); }
  const cur = drill || last;
  const params = cur && cleanParams({ ...filters, ...cur.filters, metric: cur.metric, param: cur.param });
  useEffect(() => { setPage(1); }, [drill]);
  useEffect(() => {
    if (!drill) return;
    setD(null);
    api.get("/analytics/drill", { params: { ...params, page, page_size: 25 } }).then((r) => setD(r.data)).catch(() => setD({ rows: [], columns: [], total: 0, error: true }));
  }, [drill, page]); // eslint-disable-line react-hooks/exhaustive-deps
  const pages = d ? Math.max(1, Math.ceil(d.total / 25)) : 1;
  return (
    <Sheet open={!!drill} onOpenChange={(o) => !o && onClose()}>
      <SheetContent side="right" className="w-full overflow-y-auto sm:max-w-3xl" data-testid="drill-sheet">
        <SheetHeader><SheetTitle data-testid="drill-title">{d?.title || "Dettaglio"}</SheetTitle></SheetHeader>
        {d && <div className="mt-3 flex flex-wrap items-center justify-between gap-2">
          <p className="text-sm text-slate-500" data-testid="drill-total">{d.error ? "Dati non disponibili" : `${d.total} record`}</p>
          {canExport && !d.error && <ExportButtons params={params} label={cur.metric} testId="drill-export" />}</div>}
        <div className="mt-3 overflow-x-auto"><table className="w-full text-sm">
          <thead><tr className="border-b border-line text-left text-xs text-slate-500">{d?.columns.map((c) => <th key={c.key} className="py-2 pr-3 font-medium">{moneyHeader(c)}</th>)}</tr></thead>
          <tbody>{d?.rows.map((r, i) => <tr key={r.id || i} className="border-b border-line/60" data-testid={`drill-row-${i}`}>
            {d.columns.map((c, j) => <td key={c.key} className="py-2 pr-3">{j === 0 && r.link
              ? <Link to={r.link} className="font-medium text-brand-600 hover:underline" data-testid={`drill-link-${i}`}>{fmtValue(r[c.key], c.type)}</Link>
              : fmtValue(r[c.key], c.type)}</td>)}</tr>)}</tbody></table></div>
        {d && pages > 1 && <div className="mt-4 flex items-center justify-end gap-2">
          <Button size="sm" variant="outline" disabled={page <= 1} onClick={() => setPage(page - 1)} data-testid="drill-prev">Precedente</Button>
          <span className="text-xs text-slate-500" data-testid="drill-page">{page} / {pages}</span>
          <Button size="sm" variant="outline" disabled={page >= pages} onClick={() => setPage(page + 1)} data-testid="drill-next">Successiva</Button></div>}
      </SheetContent>
    </Sheet>
  );
};
